import { create } from 'zustand'

type InviteState = {
	// Whether the invite code modal should be shown
	needsInviteCode: boolean
	// The stamped request to use for registration after code is entered
	pendingStampedRequest: unknown | null
	// Show the invite modal
	showInviteModal: (stampedRequest: unknown) => void
	// Hide the invite modal (after successful registration)
	hideInviteModal: () => void
}

export const useInviteStore = create<InviteState>(set => ({
	needsInviteCode: false,
	pendingStampedRequest: null,
	showInviteModal: stampedRequest =>
		set({ needsInviteCode: true, pendingStampedRequest: stampedRequest }),
	hideInviteModal: () => set({ needsInviteCode: false, pendingStampedRequest: null }),
}))
